export default __webpack_public_path__ + "images/d7ce9ced16e58fb7565225c38fb2fbc8.svg";